function Invitations({ invitations, onUpdate }) {

    const respond = async (meetingId, response) => {
        const token = sessionStorage.getItem("token");

        await fetch(`${process.env.REACT_APP_API_URL}/meeting/respond`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId, response })
        });

        onUpdate();
    };

    return (
        <div className="block">
            <h2>Invitations</h2>

            {invitations.map(m => (
                <div key={m._id} className="card">

                    <p>{m.description}</p>
                    <p>{new Date(m.scheduledAt).toLocaleString()}</p>

                    <div className="panel">
                        <button onClick={() => respond(m._id, "refused")}>
                            Refuser
                        </button>

                        <button className="btn-blue" onClick={() => respond(m._id, "accepted")}>
                            Accepter
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Invitations;